/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiAlbumsIdTracksPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор альбома")
    })

export const deleteApiAlbumsIdTracksQueryParamsSchema = z.object({
    "TrackIds": z.array(z.string().uuid()).describe("Список треков")
    })

/**
 * @description Трек добавлен
 */
export const deleteApiAlbumsIdTracks200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiAlbumsIdTracks400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiAlbumsIdTracks401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiAlbumsIdTracks403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Альбом не найден
 */
export const deleteApiAlbumsIdTracks404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiAlbumsIdTracks500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiAlbumsIdTracksMutationResponseSchema = z.lazy(() => deleteApiAlbumsIdTracks200Schema)